import { combineReducers } from 'redux';

import {
  REPORTS_INVOICES_SET_LIST_INVOICE,
  REPORTS_INVOICES_SET_RECEIPT,
  REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT,
  REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL,
  REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL,
  REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL,
  REPORTS_INVOICES_SET_OUTLETS,
  REPORTS_INVOICES_SET_CURRENT_PAGE,
  REPORTS_INVOICES_SET_TOTAL_PAGE,
} from '../../actions/reports/invoices/constants';
import createReducer from '../../utils/createReducer';

const currentPage = createReducer(null, {
  [REPORTS_INVOICES_SET_CURRENT_PAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.currentPage,
});

const invoices = createReducer(
  {
    results: [],
    // eslint-disable-next-line @typescript-eslint/naming-convention
    total_items: 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    total_pages: 0,
  },
  {
    [REPORTS_INVOICES_SET_LIST_INVOICE]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.invoices,
  }
);

const openCancelInvoiceModal = createReducer(false, {
  [REPORTS_INVOICES_SHOW_CANCEL_INVOICE_MODAL]: () => true,
  [REPORTS_INVOICES_HIDE_CANCEL_INVOICE_MODAL]: () => false,
});

const openOldCancelInvoiceModal = createReducer(false, {
  [REPORTS_INVOICES_SHOW_OLD_CANCEL_INVOICE_MODAL]: () => true,
  [REPORTS_INVOICES_HIDE_OLD_CANCEL_INVOICE_MODAL]: () => false,
});

const openRecordPaymentModal = createReducer(false, {
  [REPORTS_INVOICES_SHOW_RECORD_PAYMENT_MODAL]: () => true,
  [REPORTS_INVOICES_HIDE_RECORD_PAYMENT_MODAL]: () => false,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [REPORTS_INVOICES_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const page = createReducer(0, {});
const perPage = createReducer(0, {});

const receiptInvoices = createReducer(null, {
  [REPORTS_INVOICES_SET_RECEIPT]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.receiptInvoices,
});

const recordPayment = createReducer(
  {
    id: 0,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    payment_record: {},
  },
  {
    [REPORTS_INVOICES_CHANGE_FORM_RECORD_PAYMENT]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.recordPayment,
  }
);

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [REPORTS_INVOICES_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

export default combineReducers({
  currentPage,
  invoices,
  openCancelInvoiceModal,
  openOldCancelInvoiceModal,
  openRecordPaymentModal,
  outlets,
  page,
  perPage,
  receiptInvoices,
  recordPayment,
  totalPage,
});
